import api from "../utils/axios/axiosConfig";

const ticketsService = {
  create: (data) => api.post("/tickets/create", data),

  search: (params) => api.post("/tickets/search", params),

  get: (id) => api.get(`/tickets/get/${id}`),

  addMessage: (id, data) => api.post(`/tickets/message/${id}`, data),

  updateStatus: (id, data) => api.put(`/tickets/status/${id}`, data),

  getStats: () => api.get("/tickets/stats"),

  delete: (id) => api.delete(`/tickets/delete/${id}`),
  download: (filename) => api.get(`/tickets/download/${filename}`, { responseType: "blob" }),
};

export default ticketsService;
